import React, { useState, useEffect } from "react";
import { postReq, putReq, getReq } from "../middleware/AxiosApisCall";
import DataList from "../Partials/DataList";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg"; //1
import { useParams, useNavigate } from "react-router";
// import BulkUpload from "../Partials/BulkUpload";
// import TableDataWithPagination from "../Partials/TableDataWithPagination";
import TableDataPlanogram from '../Partials/TableDataPlanogram';
// bulkupload
import { csvGetReq, importCSV } from "../middleware/AxiosApisCallExport";
// import Progress from "../Partials/Progress";
import fileDownload from 'js-file-download';
import Select from 'react-select';
import Loading from "../Loading";
function Addnewmachine() {
  const [machineID, setMachineID] = useState();
  const [tableRefresh, setTableRefresh] = useState(0);
  const navigate = useNavigate();
  const path = "Machine";
  const ComponentName = "Machine";
  const subPath = "Machine/Slot";
  const listPath = "/listmachine";
  const bulkpath = 'MachineSlot';
  const [inputs, setInputs] = useState({});
  const [inputs2, setInputs2] = useState({});
  const [par, setPar] = useState(); //var to show company user form state for edit or add new req
  const { id } = useParams();
  const [itemid, setItemid] = useState(id); //var to show company  form state for edit or add new req
  // const [companyusertable, setcompanyusertable] = useState([]);
  // const [addproductformstate, setaddproductformstate] = useState(); //Add form state use to show or hide add product form
  const [bulkformstate, setbulkformstate] = useState(false);
  //TODO: Load Data on Render and on Stage changes
  const [reject, setReject] = useState(false);
  const [refillerList, setRefillerList] = useState([]);
  // const [filterRefillerList, setFilterRefillerList] = useState([]);
  // const [searchCompanyVisible, setSearchCompanyVisible] = useState(false)
  const [companyList, setCompanyList] = useState([])
  // const [filteredCompanyList, setFilteredCompanyList] = useState([]);
  // const [isSearchVisible, setSearchVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  // const [filename, setFilename] = useState("Choose File");
  // const [uploadPercentage, setUploadPercentage] = useState(0);
  // const [uploadedFile, setUploadedFile] = useState({});

  const companypath = "Company/Datalist";
  const refillerPath="User/DataList?role=Refiller"
  // This API is used to get Company details


  
  const onChange = (e) => {
    setFile(e.target.files[0]);
    // setFilename(e.target.files[0].name);
  };

  // console.log('reject:',reject);

  const sampleCSVFile = async () => {
    const response = await csvGetReq(`${bulkpath}/SampleCSV`);
    if (response) {
      // console.log('FileSmaple:', response)
      fileDownload(response, "csvreport.csv");
      SuccessAlert({
        title: "Sample Upload File",
        message: "Sample Upload file Downloaded successfully",
      });
    } else {
      ErrorAlert({ title: "Update Slot", message: response.msg });
    }
  };



  const bulkUpload = async (event) => { //TODO:Submit Search Form
    setLoading(true)
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
     const response = await importCSV(`${bulkpath}`, formData);
    if (response?.success) {
      if (response.data?.dataupload === "success") {
        SuccessAlert({
          title: `Import ${ComponentName} File`,
          message: `Import  ${ComponentName} file Uploaded successfully`,
        });


        setTableRefresh(tableRefresh + 1)

        // props.importSuccess();
        setLoading(false)
      }
      else {
        rejectdata(response.data.reject_data);
        ErrorAlert({ title:`${response.data.reject_data.length} Data Rejected `, message:'Data Rejected' });
        setLoading(false)
      }
    } else {
      ErrorAlert({ title: "Import File ", message:"import file has problem" });
      setLoading(false)
    }

  };


  // This function is for getting company details
  const loadCompanyinfo = async () => {
    const response = await getReq(`${companypath}`)
    if (response?.success) {
      setCompanyList(response.data)
      // setFilterRefillerList(response.data)
    }
  }

  const mappedCompany=companyList.map(info=>({
    value:info.companyid,
    label:info.companyname
   }))

  // console.log('mappedCompany:',mappedCompany)
  // This function is for getting Refiller details
  const loadRefiller = async () => {
      const response = await getReq(`${refillerPath}`)
      if(response?.success){
        setRefillerList(response.data)
        // setFilterRefillerList(response.data)
      }
  }
// console.log('refillerList:',refillerList)

const mappedRefiller=refillerList.map(data=>({
  value:data.user_id,
  label:data.first_name
 }))

 const handleSelected=(selected)=>{
  setInputs((values) => ({ ...values, companyid:selected.value }));
}

const handleSelectedRefiller=(selected)=>{
 setInputs((values) => ({ ...values, refiller:selected.value }));
}

const custumStyle={
  control:(provided)=>({
    ...provided,
    fontSize:'14px',
    width:'230px',
    lineHeight: 1.5,
    backgroundColor:'#dee1e2',
    border: '2px solid #dee1e2',
    height: '20px',
    
  })
}

    useEffect(() => {
    loadCompanyinfo()
    loadRefiller()

  }, [])

  


  // const handleSearch = (e, id) => {
  //   const { name, value } = e.target;
  //   setSearchVisible(true)
  //   setInputs((prev) => ({ ...prev, [name]: value }))
  //   const filtered = refillerList.filter(refiller =>
  //     refiller.first_name.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setFilterRefillerList(filtered);
  // };
  // console.log('filterRefillerList:',filterRefillerList)

//   const handleSearchcompany = (e, id) => {
//     const { name, value } = e.target;
//     console.log('value: ', value);

//     setSearchCompanyVisible(true)
//     setInputs((prev) => ({ ...prev, [name]: value }))
   
//     const filteredcompany = companyList.filter(company =>
//              // console.log('companyName:',company.companyname)
//             // company.companyname.toLowerCase().includes(value.toLowerCase())
//             company.companyname.toLowerCase().includes(value.toLowerCase())
//     )
//     // console.log('filteredcompany:',filteredcompany)
//     setFilteredCompanyList(filteredcompany);
//   };

// console.log('filteredCompanyList:',filteredCompanyList)

  // const handleRefillerSet = (refiller, e) => {
  //   // console.log('refiller: ', refiller);
  //   setInputs((prev) => ({ ...prev, refiller: refiller.user_id }));
  //   setSearchVisible(false);
  // }
  // const handlecompanySet = (company, e) => {
  //   // console.log('refiller: ', company);
  //   // console.log(company.companyid);
  //   setInputs((prev) => ({ ...prev, companyid: company.companyid }));
  //   setSearchCompanyVisible(false);
  // }



  const bulkupload = () => {
    //TODO:Handle Hide and Show of Add Product From
    if (reject) {
      setReject(false);
      setTableRefresh(tableRefresh+1)
    }
    setbulkformstate(!bulkformstate);

    // setaddproductformstate(false);
  };
  const rejectdata = () => {
    setReject(true);
    setTableRefresh(tableRefresh+1)
  };
  // Bulkupload end here


  const loadDate = async () => {
    const response = await getReq(`${path}/${itemid}`);
    // console.log('loadDate:', response.data)
    if (response?.data) {
      // console.log("RESPONSE:", response.data);
      setInputs2((values) => ({
        ...values,
        machineid: response.data.machineid,
      }));
      setInputs(response.data);
      // console.log('response.data.machineid:',response.data.machineid)
      setMachineID(response.data.machineid);
    } else {
      navigate(`../`);
    }
  };

  // console.log('MachineID:',machineID)
  // const loadDateUsertable = async () => {
  //   const response = await getReq(`${subPath}/${itemid}`);
  //   console.log('loadDateusertable:', response.data)
  //   console.log('itemid:', itemid)
  //   if (response.data?.length) {

  //     setcompanyusertable(response.data);
  //   } else {
  //     setcompanyusertable([]);
  //   }
  // };

  const loadSubFormData = async (assignid) => {
    const response = await getReq(`${subPath}/${itemid}/${assignid}`);
    // console.log('RESPONSE ,FOR,ItemID:',response);
    // console.log('assignid:', assignid)
    if (response.data?.length) {
      setInputs2(response.data[0]);
    }
    //  else {
    //   setcompanyusertable([]);
    // }
  };

  //TODO:Handle Form Data  SHange and Submit
  function handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  }

  function handleChange2(event) {
    // console.log('event:',event.target.value)
    // console.log('Name:',event.target.name)
    const name = event.target.name;
    const checked = event.target.checked;
    if (event.target.type === "checkbox") {
      setInputs2((values) => ({ ...values, [name]: checked }));
    } else {
      setInputs2((values) => ({ ...values, [name]: event.target.value }));
    }
  }

  const handleSubmit2 = async (event) => {
    event.preventDefault();
    if (par) {
      const response = await putReq(subPath, inputs2, par);
      if (response.success) {
        SuccessAlert({
          title: " Update Slot",
          message: "Slot Details Updated successfully",
        });
        // setPar(); 24
        // loadDateUsertable();
        setInputs2({});
        setTableRefresh(tableRefresh+1)
        setInputs2((values) => ({
          ...values,
          machineid: inputs2.machineid,
        }));
        setPar(false)
        setTableRefresh(tableRefresh + 1);
        loadDate();
      } else {
        ErrorAlert({ title: "Update Slot", message: response.msg });
      }
    } else {
      const response = await postReq(subPath, inputs2);
      if (response.success) {
        SuccessAlert({
          title: "Create Slot",
          message: "Slot Created successfully",
        });
        // loadDateUsertable();
        setInputs2({});
        setTableRefresh(tableRefresh+1)
        setInputs2((values) => ({
          ...values,
          machineid: inputs2.machineid,
        }));
        setTableRefresh(tableRefresh + 1);
        // console.log('tableRefresh:', tableRefresh)
        // loadDate(); 24
      } else {
        ErrorAlert({ title: "Create Slot", message: response.msg });
      }
    }
  };

  const handleSubmit = async (event) => {

    event.preventDefault();
    if (itemid) {
      // console.log("ItemID:", itemid);
      // console.log('inputs: ', inputs);
      const response = await putReq(path, inputs, itemid);

      if (response.success) {
        SuccessAlert({
          title: "Update Machine",
          message: "Machine Updated successfully",
        });
        // setItemid(response.data._id);
        //  console.log('itemid,:',response.data._id)
        // navigate(`${response.data.machineid}`);
        setItemid(response.data.machineid);
        setInputs2((values) => ({
          ...values,
          machineid: inputs.machineid,
        }));

        // loadDateUsertable();
        // loadDateUsertable();
        setTableRefresh(tableRefresh + 1);

        // loadDate();

        // console.log("inputs2:", inputs2);
        // setaddproductformstate(false);
      } else {
        ErrorAlert({ title: "Update Machine", message: response.msg });
      }
    } else {
      const response = await postReq(path, inputs);

      if (response?.success) {
        SuccessAlert({
          title: "Add Machine",
          message: "Machine Added successfully",
        });
        // console.log("Response:", response.data);

        navigate(`${response.data.machineid}`);
        setItemid(response.data.machineid);
        setInputs2((values) => ({
          ...values,
          machineid: inputs.machineid,
        }));
        // console.log("inputs.machineID:", inputs.machineid);
      } else {
        ErrorAlert({ title: "Add Machine", message: response.msg });
      }
    }
  };
  const editClick = (pid) => {
    loadSubFormData(pid._id);
    setPar(pid._id);
  };
  //TODO: State Handle on Edit Company and After Added Company to Load Form Fields byusing useState "itemid"
  useEffect(() => {
    if (itemid) {
      loadDate();
      // loadDateUsertable();
    }
  }, [itemid]);
  //TODO: State Handle on Edit Company and After Added Company to Load Form Fields by using route paramsuseState "id"

  useEffect(() => {
    if (id) {
      setItemid(id);
    } else {
      // setcompanyusertable([]);
      setInputs2({});
      setInputs({});
      setItemid();
      setPar();
    }
  }, [id]);

 
  return (
    <React.Fragment>
      <div className="add-user-container">
        <div className="headingdiv">
          <span className="componet-title">
            {itemid
              ? `Edit ${ComponentName} Details`
              : `Add ${ComponentName} Details`}{" "}
          </span>
          <div>
            <button onClick={() => navigate(-1)}>Back</button>
          </div>
        </div>
        <div className="option-btn">
          <button
            onClick={() => {
              navigate(listPath);
            }}
          >
            {ComponentName} List
          </button>

          {(par || itemid) && (
            <button onClick={bulkupload}>
              {bulkformstate ? "Single Slot Upload" : "Bulk Slot Upload"}
            </button>
          )}
        </div>

        <form className="flex-row form-2col-ver"  onSubmit={handleSubmit}>
          <div className="flex-row" >
            <div className="input-lable-h-div">
              <label htmlFor="machineid"> Machine ID</label>
              <input
                // This ref and onKeypress for Focus next input field after Clicking on Enter button
                // ref={inputRefs[0]}
                // onKeyPress={(e) => handleKeyPress(e, 0)}
                type="text"
                name="machineid"
                value={inputs.machineid || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div className="input-lable-h-div">
              <label htmlFor="machinename">Machine Name</label>
              <input
                // This ref and onKeypress for Focus next input field after Clicking on Enter button
                //  ref={inputRefs[1]}
                //  onKeyPress={(e) => handleKeyPress(e, 1)}
                type="text"
                name="machinename"
                value={inputs.machinename || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            {/* <DataList
                value={inputs.companyid || ""}
                path={"Company"}
                handleChange={handleChange}
                name={"companyid"}
                option={"companyid"}
                heading={"Company"}
              /> */}

            <div style={{ position: "relative", width: "80%" }} className="input-lable-h-div">
              <label htmlFor="totalslots">Company</label>
               <Select
               styles={custumStyle}
               options={mappedCompany}
               name="companyid"
               value={ mappedCompany.find(option=>option.value===inputs.companyid) }
               placeholder="Select Company"
               onChange={handleSelected}
               />
             {/* 
              <input
                type="text"
                placeholder="Search by name"
                name="companyid"
                value={inputs.companyid || ""}
                onChange={(e) => handleSearchcompany(e)}
                autoComplete="off"
              />

              {searchCompanyVisible && (
                <div style={{
                  maxHeight: '300px',
                  overflowY: 'scroll',
                  border: "1px solid black",
                  width: "max-content",
                  backgroundColor: "rgba(0, 0, 0, 0.900)",
                  color: "white",
                  position: "absolute",
                  top: "100%",
                  right: "0%",
                  scrollbarWidth: '50px',
                  scrollbarColor: 'gray'

                }}>
                  {filteredCompanyList.map(company => (
                    <p
                      key={company._id}
                      value={company.companyid}
                      style={{
                        border: "0.1px solid gray",
                        color: "white",
                        padding: "10px 20px"

                      }}
                      onClick={(e) => handlecompanySet(company, e)}
                    >
                      {company.companyname}
                    </p>
                  ))}
                </div>
              )} */}

            </div>



            <div className="input-lable-h-div">
              <label htmlFor="building">Building Name/No </label>
              <input
                type="text"
                name="building"
                value={inputs.building || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div className="input-lable-h-div">
              <label htmlFor="location">Location </label>
              <input
                type="text"
                name="location"
                value={inputs.location || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>
            <div className="input-lable-h-div">
              <DataList
                name={"warehouse"}
                value={inputs.warehouse || " "}
                path={"getAllWarehouses"}
                option={"wareHouseName"}
                handleChange={handleChange}
                heading={"Warehouse"}
              />
            </div>
            <div className="input-lable-h-div">
              <label htmlFor="producttype">Product Type </label>
              <input
                type="text"
                name="producttype"
                value={inputs.producttype || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div className="input-lable-h-div">
              <label htmlFor="totalslots">Total Slots </label>
              <input
                type="number"
                name="totalslots"
                value={inputs.totalslots || ""}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div style={{ position: "relative", width: "80%" }} className="input-lable-h-div">
              <label htmlFor="totalslots">Assign Refiller</label>
              <Select
               styles={custumStyle}
               options={mappedRefiller}
               name="refiller"
               value={ mappedRefiller.find(option=>option.value===inputs.refiller)}
               placeholder="Select Refiller"
               onChange={handleSelectedRefiller}
               />
             
             
              {/* <input
                type="text"
                placeholder="Search by name"
                name="refiller"
                value={inputs.refiller || ""}
                onChange={(e) => handleSearch(e)}
                autoComplete="off"
              />
              {isSearchVisible && (
                <div style={{
                  maxHeight: '300px',
                  overflowY: 'scroll',
                  border: "1px solid black",
                  width: "max-content",
                  backgroundColor: "rgba(0, 0, 0, 0.900)",
                  color: "white",
                  position: "absolute",
                  top: "100%",
                  right: "0%",
                  scrollbarWidth: '50px',
                  scrollbarColor: 'gray',
               

                }}>
                  {filterRefillerList.map(refiller => (
                    <p
                      key={refiller._id}
                      value={refiller.user_id}
                      style={{
                        border: "0.1px solid gray",
                        color: "white",
                        padding: "10px 20px",
                       zIndex:-1000
                      }}
                      onClick={(e) => handleRefillerSet(refiller, e)}
                    >
                      {refiller.first_name} {refiller.last_name}
                    </p>
                  ))}
                </div>
              )} */}

            </div>

            <div className="input-lable-h-div">
              <button className="submit-btn" type="submit">
                {itemid ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* second form */}
      {/* (!addproductformstate&&!bulkformstate) */}

      {itemid && (
        <React.Fragment>
          <div className="add-user-container">
            {/*  bulkupload form*/}
            {bulkformstate ? (

              // <BulkUpload
              //   path={"MachineSlot"}
              //   key={tableRefresh}
              //   rejectdata={rejectdata}
              //   ComponentName={"Planogram"}
              // />
              <div className="add-user-container">
                <div className="componet-sub-title flex-col flex-space-bt">
                  <span>

                    {`Bulk ${ComponentName} Upload`}
                  </span>
                  <div className="option-btn">
                    <button onClick={sampleCSVFile}>
                      {`Download Sample file`}
                    </button>
                  </div>
                </div>

                {/* {(uploadPercentage !== 0) && <Progress percentage={uploadPercentage} />} */}

                {loading ? (<Loading/>) :(<form className="flex-col" onSubmit={bulkUpload}>
                  <div className="input-lable-v-div">
                    <label htmlFor="file">Select File</label>
                    <input className="file-upload-input"
                      type="file"
                      onChange={onChange}
                      id="file"
                    />
                  </div>

                  <div className="input-lable-h-div">
                    <button className="submit-btn" type="submit">
                      {loading ? 'Uploading...' : 'Upload'}
                    </button>
                  </div>

                  {/* {uploadedFile ? (
                    <div>
                      <div>
                        <h3>{uploadedFile.fileName}</h3>
                        <img style={{ width: "100%" }} src={uploadedFile.filePath} alt="" />
                      </div>
                    </div>
                  ) : null} */}
                </form>) }
              </div>

            ) : (
              <>
                <div className="componet-sub-title">
                  <span>{par ? "Update Planogram" : "Make Planogram"}</span>
                </div>

                <form className="flex-col" onSubmit={handleSubmit2}>
                  <div className="input-lable-h-div">
                    {/* <DataList
                      value={inputs2.machineid || ""}
                      path={path}
                      handleChange={handleChange2}
                      name={"machineid"}
                      option={"machineid"}
                      heading={"Machine ID"}
                    /> */}
                    
                    <label htmlFor="slot">Machine ID</label>
                    <input
                      type="text"
                      name="machineid"
                      placeholder={inputs2.machineid || ""}
                      // onChange={handleChange2}
                      autoComplete="off"
                    />
                    
                  </div>

                  <div className="input-lable-h-div">
                    <label htmlFor="slot">Slot Name/No.</label>
                    <input
                      type="text"
                      name="slot"
                      value={inputs2.slot || ""}
                      onChange={handleChange2}
                      autoComplete="off"
                    />
                  </div>

                  <div className="input-lable-h-div">
                    <label htmlFor="maxquantity">MAX Quantity</label>
                    <input
                      type="number"
                      name="maxquantity"
                      value={inputs2.maxquantity || ""}
                      onChange={handleChange2}
                      autoComplete="off"
                    />
                  </div>

                  <div className="input-lable-h-div">
                    <DataList
                      name={"product"}
                      value={inputs2.product || " "}
                      path={"Product"}
                      option={"productname"}
                      // price={"sellingprice"}
                      handleChange={handleChange2}
                      heading={"Product"}
                    />
                  </div>

                  {/* <div className="input-lable-v-div">
                    <label htmlFor="active_status">Activate</label>
                    <input
                      type="checkbox"
                      name="active_status"
                      value={inputs2.active_status || false}
                      checked={inputs2.active_status || false}
                      onChange={handleChange2}
                      autoComplete="off"
                    />
                  </div> */}

                  <div className="input-lable-h-div">
                    <button className="submit-btn" type="submit">
                      {par ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
          <div className="table_container-div">

            {/* <TableDataWithPagination
             
              path={subPath}
              key={tableRefresh}
              machineID={machineID}
              editClick={editClick}
              reject={reject}
            /> */}
            <TableDataPlanogram
             path={subPath}
             key={tableRefresh}
             machineID={machineID}
             editClick={editClick}
             reject={reject}
            />
           
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default Addnewmachine;
